import { useEffect, useState } from 'react';
import { Input, Range } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import formatAmount from '@modules/calculator/utils/formatAmount';
export const AmountRangeInput = ({ min, max, step, value, onChange, validateAmountError, className = '', error, }) => {
    const { t } = useTranslation();
    const [rangeValue, setRangeValue] = useState(value);
    const [inputValue, setInputValue] = useState(formatAmount(value));
    const validateAmount = (amount) => {
        if (amount > max || amount < min || amount % step !== 0) {
            validateAmountError();
            return false;
        }
        return true;
    };
    const handleChange = (event) => {
        var _a;
        const newValue = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
        const sanitizedValue = newValue.replace(/[^0-9.,€\s]/g, '');
        setInputValue(sanitizedValue);
    };
    const handleBlur = () => {
        const enteredValue = inputValue.replace(/[€\s,]/g, '');
        const enteredNumber = parseFloat(enteredValue);
        if (Number.isNaN(enteredNumber)) {
            setInputValue(formatAmount(min));
            return;
        }
        onChange(enteredNumber);
        if (!validateAmount(enteredNumber)) {
            validateAmountError();
            setInputValue(formatAmount(enteredNumber));
            return;
        }
        setInputValue(formatAmount(enteredNumber));
        setRangeValue(enteredNumber);
        validateAmountError();
    };
    const handleSelect = (amount) => {
        onChange(amount);
        if (amount > max) {
            setRangeValue(max);
        }
        else if (amount < min) {
            setRangeValue(min);
        }
        else {
            setRangeValue(amount);
        }
    };
    useEffect(() => {
        setInputValue(formatAmount(value));
        handleSelect(value);
    }, [value]);
    const isSingleValue = min === max;
    const marks = [
        ...(isSingleValue
            ? []
            : [
                {
                    label: t('financing.investment_details.min_label', { amount: formatAmount(min, true, false) }),
                    value: min,
                },
            ]),
        {
            label: t('financing.investment_details.max_label', { amount: formatAmount(max, true, false) }),
            value: max,
        },
    ];
    return (<div className={`flex flex-col md:flex-row md:justify-between items-start content-start gap-x-8 max-w-full ${className}`}>
            <div className="w-full">
                <Range min={isSingleValue ? 0 : min} max={max} marks={marks} onChange={handleSelect} value={rangeValue} step={step} disabled={isSingleValue}/>
            </div>

            <div className="md:px-4">
                <Input id="investmentAmountId" className="w-36 justify-end text-right" label={t('financing.investment_details.set_amount')} value={inputValue} onChange={handleChange} onBlur={handleBlur} isError={!!error}/>
            </div>
        </div>);
};
